import { updateContentsList } from 'api'
import { deleteNotification } from 'api/post/pushNotification'
import clsx from 'clsx'
import { HeaderTableItem, Pagination, Typography } from 'components'
import { ConfirmDelete } from 'components/pushNotification/delete/ConfirmDelete'
import { useToast } from 'hooks'
import {
	ChildrenTableProps,
	EditContentListBody,
	EditContentListResponse,
	PaginationType,
	ReachListItem,
	TypographyTypes
} from 'interfaces'

import React, { useState } from 'react'
import Cookies from 'universal-cookie'

export const MyReachTable: React.FC<ChildrenTableProps<ReachListItem[]>> = ({
	data,
	backendPages,
	headers,
	customWidth,
	justify = 'center',
	bodyTableClassName,
	actionsButton,
	actionColumn = 'left',
	actionColumnWidth = 5,
	page,
	setPage,
	refetch,
	setLoading,
	dataNotification,
	onShowingItemsChange,
	onShowingItems
}): JSX.Element => {
	const cookies = new Cookies()
	const { showToast } = useToast()
	const [listToDelete, setListToDelete] = useState<number | null>(null)
	const [messageModalToDelete, setMessageModalToDelete] = useState<{
		title: string
		id: number
		category: string
	} | null>(null)
	const organizationId = cookies.get('organization_id')

	const onPageChanged = (pages: PaginationType): void => {
		const newPage = pages.currentPage
		if (setPage) {
			setPage(newPage)
		}
	}

	const handleRefetchTable = (
		res: EditContentListResponse | undefined
	): void => {
		if (res?.message) {
			if (refetch) {
				refetch()
			}
			if (setLoading) setLoading(false)
		}
	}

	const deleteHandler = async (
		id: number,
		category: string | null
	): Promise<void> => {
		if (setLoading) setLoading(true)
		if (category) {
			const body = {
				status: 'deleted'
			} as EditContentListBody
			const res = await updateContentsList(organizationId, id, body)
			handleRefetchTable(res)
			setMessageModalToDelete(null)
		} else {
			const res = await deleteNotification(organizationId, id)
			if (res?.message)
				showToast('Success', 'Notification successfully removed', 'success')

			handleRefetchTable(res)
		}
	}

	const callToAction = (): void => {
		if (messageModalToDelete !== null) {
			deleteHandler(messageModalToDelete.id, messageModalToDelete.category)
		} else {
			deleteHandler(listToDelete as number, '')
		}
		setListToDelete(null)
	}

	const calculateWidhtColumn = (): number => {
		const values = data?.map(e => e.order as number)
		const maxValues = Math.max(...(values as number[]))
		const total = 40
		const widthAction = (maxValues.toString().length / total) * 100

		return widthAction
	}

	return (
		<>
			<div className={clsx('w-full', backendPages === 1 && 'mb-[20px]')}>
				<div className="py-2 px-1 bg-white border-2 border-blue-primary rounded-lg w-full min-w-max">
					<table className="w-full min-h-max min-w-max">
						<thead className="flex w-full h-5 mb-3">
							<tr className="w-full flex justify-between items-center">
								{actionsButton && actionColumn === 'left' && (
									<th
										scope="col"
										className="flex items-center justify-center text-[15px] leading-[18px] text-gray-9 font-bold cursor-pointer"
										style={{
											flexBasis: `${
												calculateWidhtColumn() || actionColumnWidth
											}%`
										}}
									>
										{dataNotification ? 'Action' : 'Actions'}
									</th>
								)}

								<HeaderTableItem
									header="Name"
									justify={justify}
									table="myReachList"
									column="name"
									style={
										customWidth
											? { flexBasis: `${customWidth[0]}%` }
											: { flexBasis: `${100 / 9}%` }
									}
								/>
								<HeaderTableItem
									header="Email"
									justify={justify}
									table="myReachList"
									column="email"
									style={
										customWidth
											? { flexBasis: `${customWidth[1]}%` }
											: { flexBasis: `${100 / 9}%` }
									}
								/>
								<HeaderTableItem
									header="Tags"
									justify={justify}
									table="myReachList"
									column="tags"
									style={
										customWidth
											? { flexBasis: `${customWidth[2]}%` }
											: { flexBasis: `${100 / 9}%` }
									}
								/>
							</tr>
						</thead>
						<tbody
							className={clsx(
								bodyTableClassName,
								'w-full h-auto h-[14rem] overflow-y-scroll flex flex-col gap-2 '
							)}
						>
							{data?.map(item => (
								<tr
									key={`${item.id}`}
									className="w-full flex justify-between h-max"
								>
									{headers && (
										<>
											<td
												className={clsx(
													'font-Inter',
													'w-full  flex items-center text-[15px] leading-[18px] text-gray-9',
													justify === 'center' && 'justify-center text-center',
													justify === 'left' && 'justify-left text-left',
													justify === 'right' && 'justify-right text-right'
												)}
												style={
													customWidth
														? { flexBasis: `${customWidth[0]}%` }
														: { flexBasis: `${100 / headers.length}%` }
												}
											>
												{item.name}
											</td>
											<td
												className={clsx(
													'font-Inter',
													'w-full  flex items-center text-[15px] leading-[18px] text-gray-9',
													justify === 'center' && 'justify-center text-center',
													justify === 'left' && 'justify-left text-left',
													justify === 'right' && 'justify-right text-right'
												)}
												style={
													customWidth
														? { flexBasis: `${customWidth[1]}%` }
														: { flexBasis: `${100 / headers.length}%` }
												}
											>
												{item.email}
											</td>
											<td
												className={clsx(
													'font-Inter',
													'w-full  flex items-center text-[15px] leading-[18px] text-gray-9',
													justify === 'center' && 'justify-center text-center',
													justify === 'left' && 'justify-left text-left',
													justify === 'right' && 'justify-right text-right'
												)}
												style={
													customWidth
														? { flexBasis: `${customWidth[2]}%` }
														: { flexBasis: `${100 / headers.length}%` }
												}
											>
												<div className="flex items-center gap-1">
													{item.tags.length > 0 ? (
														<>
															<div
																className={clsx(
																	'flex items-center justify-center p-1 border border-blue-primary rounded-3xl max-h-[25px] gap-1 w-[100px] text-blue-primary'
																)}
															>
																<Typography
																	key="0"
																	title={item.tags[0]}
																	fontLeading="12/15"
																	type={TypographyTypes.span}
																	className={clsx(
																		'!font-normal text-blue-primary truncate'
																	)}
																/>
															</div>
															{item.tags.length > 1 && (
																<div className="flex items-center justify-center p-1 border border-blue-primary rounded-3xl w-[35px] h-[25px] text-blue-primary">
																	<Typography
																		key="0"
																		title={`+${item.tags.length - 1}`}
																		fontLeading="12/15"
																		type={TypographyTypes.span}
																		className="!font-normal text-blue-primary "
																	/>
																</div>
															)}
														</>
													) : (
														<div className="text-gray-500 hidden">No tags</div>
													)}
												</div>
											</td>
										</>
									)}
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div className="w-full flex items-center justify-end">
					<Pagination
						totalRecords={backendPages ?? 1}
						onPageChanged={onPageChanged}
						page={page}
						pageLimit={1}
						onShowingItemsChange={onShowingItemsChange}
						itemsShowing={onShowingItems}
					/>
				</div>
			</div>
			<ConfirmDelete
				open={listToDelete !== null}
				setOpen={() => {
					setListToDelete(null)
					setMessageModalToDelete(null)
				}}
				onClickConfirm={() => {
					if (listToDelete) {
						callToAction()
					}
				}}
				title={messageModalToDelete?.title}
			/>
		</>
	)
}
